// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"24381274","272":"2f8b5a3d","441":"8a6b9f9c","787":"a5edc4e2","917":"3ca4a51e"}[chunkId] + ".chunk.js";
};